import { motion } from "framer-motion";

export default function MeetAlex() {
  return (
    <section data-testid="meet-alex-section" className="bg-[#0A0908] py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="flex-shrink-0"
          >
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-full overflow-hidden border-4 border-[#C2A878]/30 shadow-2xl">
              <img
                alt="Alex Moore, Head of Memory Making"
                className="w-full h-full object-cover"
                data-testid="meet-alex-photo"
                src="https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/ifu7svtq_IMG_1066.jpeg"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="text-center md:text-left"
          >
            <p className="text-xs tracking-[0.2em] uppercase text-[#C2A878] font-sans mb-3">
              Your personal guide
            </p>
            <h2
              data-testid="meet-alex-heading"
              className="font-serif text-2xl sm:text-3xl tracking-tight font-light text-[#F5F5F0] mb-2"
            >
              Meet Alex
            </h2>
            <p className="text-sm text-[#A19D94]/60 font-sans italic mb-5">
              Head of Memory Making
            </p>
            <p className="text-base text-[#A19D94] font-sans leading-relaxed mb-4">
              From your very first message to the moment you watch your finished film, Alex is with you the whole way. No call centres. No being passed around. Just one person who genuinely cares about getting your day right.
            </p>
            <p className="text-sm text-[#A19D94]/70 font-sans leading-relaxed">
              He founded Wedding Video Essex in 2015 because he believes every couple deserves a film that makes them feel it all again. Over 900 happy couples later, he still gets emotional watching the final edits.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
